/** Strips HTML tags, returning plain text. SSR-safe via regex fallback. */
export function stripHtml(html: string): string {
  if (typeof DOMParser !== "undefined") {
    return new DOMParser().parseFromString(html, "text/html").body.textContent ?? "";
  }
  return html.replace(/<[^>]*>/g, "");
}
